/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_VoicesInputs */

const en_common_voices = /** @type {(inputs: Common_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voices`)
};

const es_common_voices = /** @type {(inputs: Common_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces`)
};

/**
* | output |
* | --- |
* | "Voices" |
*
* @param {Common_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_voices = /** @type {((inputs?: Common_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_voices(inputs)
	return en_common_voices(inputs)
});